export const templateBarbearia = {

config:{
cor_primaria:"#0f0f0f",
tipo_fundo:"solido",
bg_size:"cover",
bg_pos_x:50,
bg_pos_y:50,
fonte_principal:"Montserrat"
},

elementos:[

{
id:1,
tipo:"texto",
conteudo:"THE BARBER SHOP",
pos_x:40,
pos_y:40,
estilo:{
fontSize:34,
color:"#d4af37",
fontFamily:"Playfair Display",
fontWeight:"900",
letterSpacing:"3px"
}
},

{
id:2,
tipo:"texto",
conteudo:"✂ ESTILO CLÁSSICO & MODERNO ✂",
pos_x:60,
pos_y:85,
estilo:{
fontSize:14,
color:"#bbbbbb",
fontFamily:"Montserrat",
letterSpacing:"2px"
}
},

{
id:3,
tipo:"texto",
conteudo:"SERVIÇOS",
pos_x:130,
pos_y:130,
estilo:{
fontSize:22,
color:"#ffffff",
fontFamily:"Oswald",
fontWeight:"bold"
}
},

{
id:4,
tipo:"texto",
conteudo:"──────────────",
pos_x:120,
pos_y:160,
estilo:{
fontSize:20,
color:"#d4af37"
}
},

{
id:5,
tipo:"texto",
conteudo:"✂ Corte Degradê",
pos_x:40,
pos_y:200,
estilo:{
fontSize:16,
color:"#ffffff",
fontFamily:"Montserrat"
}
},

{
id:6,
tipo:"texto",
conteudo:"R$ 40,00",
pos_x:260,
pos_y:200,
estilo:{
fontSize:16,
color:"#d4af37",
fontFamily:"Montserrat",
fontWeight:"bold"
}
},

{
id:7,
tipo:"texto",
conteudo:"🪒 Barba Terapia",
pos_x:40,
pos_y:240,
estilo:{
fontSize:16,
color:"#ffffff",
fontFamily:"Montserrat"
}
},

{
id:8,
tipo:"texto",
conteudo:"R$ 35,00",
pos_x:260,
pos_y:240,
estilo:{
fontSize:16,
color:"#d4af37",
fontFamily:"Montserrat",
fontWeight:"bold"
}
},

{
id:9,
tipo:"texto",
conteudo:"🔥 Combo Corte + Barba",
pos_x:40,
pos_y:280,
estilo:{
fontSize:16,
color:"#ffffff",
fontFamily:"Montserrat"
}
},

{
id:10,
tipo:"texto",
conteudo:"R$ 70,00",
pos_x:260,
pos_y:280,
estilo:{
fontSize:18,
color:"#d4af37",
fontFamily:"Montserrat",
fontWeight:"bold"
}
},

{
id:11,
tipo:"texto",
conteudo:"HORÁRIO DE FUNCIONAMENTO",
pos_x:70,
pos_y:340,
estilo:{
fontSize:14,
color:"#aaaaaa",
fontFamily:"Montserrat"
}
},

{
id:12,
tipo:"texto",
conteudo:"Seg - Sab | 09:00 às 20:00",
pos_x:80,
pos_y:370,
estilo:{
fontSize:14,
color:"#ffffff",
fontFamily:"Montserrat"
}
}

]

};